import _ from "lodash";
import {
  EMPTY_CANDIDATES,
  EMPTY_CANDIDATE_DETAILS,
  FETCH_CANDIDATES,
  FETCH_CANDIDATE_DETAILS,
  FETCH_CANDIDATE_ENGAGEMENTS,
  FETCH_CANDIDATE_JOB_MATCHES,
  FETCH_CANDIDATE_MATCHES,
  FETCH_CANDIDATE_SKILLS_INFO,
  FETCH_COINS,
  FETCH_ALL_OCCUPATIONS,
  SET_NEW_SKILLS,
  FETCH_VALIDATION_REQUESTS,
  FETCH_CANDIDATE_PROJECTS
} from "./types";
import { get, post } from "./api";
import { ConsoleLogger } from "aws-amplify/utils";
const logger = new ConsoleLogger("CANDIDATES.ACTIONS");

// Cognito - Auth.signIn()
export function fetchCandidates() {
  return async function (dispatch, getState) {
    var contractID = null;
    const state = getState();
    if (
      state.portaldetails.selectedContract &&
      state.portaldetails.selectedContract.contractID
    ) {
      contractID = state.portaldetails.selectedContract.contractID;
    }

    try {
      if (!contractID) {
        dispatch({ type: EMPTY_CANDIDATES, candidates: null });
        return;
      }
      let data = null;

      const currentKeyWorkerId = state.portaldetails.currentKeyWorker
        ? state.portaldetails.currentKeyWorker
        : state.portaldetails.user.userID;
      data = await get(`/keyworker/${currentKeyWorkerId}/candidates/${contractID}`);
      if (data.data && !_.isEmpty(data.data)) {
        dispatch({ type: FETCH_CANDIDATES, candidates: data.data });
      } else {
        dispatch({ type: FETCH_CANDIDATES, candidates: [] });
      }
    } catch (e) {
      dispatch({ type: FETCH_CANDIDATES, candidates: [] });
    }
  };
}

export function fetchCandidatesIM() {
  return async function (dispatch, getState) {
    const {portaldetails:{selectedProvider, currentDepartment, currentLineManager}} = getState();
    try {
      const data = await post("/keyworker/candidates/getIM", {
        lineManagerID: currentLineManager,
        departmentID: currentDepartment,
        provider: selectedProvider ? selectedProvider.sort : false
      });
      if (data.data && !_.isEmpty(data.data)) {
        dispatch({ type: FETCH_CANDIDATES, candidates: data.data });
      } else {
        dispatch({ type: FETCH_CANDIDATES, candidates: [] });
      }
    } catch (e) {
      dispatch({ type: FETCH_CANDIDATES, candidates: [] });
    }
  };
}

export function fetchCandidateDetails(candidate, keyworkerId) {
  return async function (dispatch, getState) {
    const state = getState();
    dispatch({
      type: EMPTY_CANDIDATE_DETAILS,
      selectedCandidate: null,
    });

    try {
      if (candidate) {
        let currentKeyWorkerId = state.portaldetails.currentKeyWorker
          ? state.portaldetails.currentKeyWorker
          : state.portaldetails.user.userID;

        if (keyworkerId){
          currentKeyWorkerId = keyworkerId;
        }
        let data = await get(`/keyworker/${currentKeyWorkerId}/candidate/${candidate.userID}`);
      
        if (data.data) {
          await dispatch({
            type: FETCH_CANDIDATE_DETAILS,
            selectedCandidate: data.data,
          });
          dispatch(fetchValidationRequests());
          const { candidates: { selectedCandidateData  } } = getState();

          let {
            latestAssessmentResult,
            desiredExp,
            desiredOccupations,
            occupationsExtended,
            desiredOccupationsExtended,
            occupations,
            qualifications,
            skills_names,
            occupationsOriginal,
            desiredOccupationsOriginal,
            userID,
            coinsObject,
            internalMobilityProvider
          } = selectedCandidateData;
            
          let payload = {
            latestAssessmentResult,
            desiredOccupations,
            occupationsExtended,
            occupations: [...occupations],
            desiredExp,
            qualifications,
            calculateQualifications: false,
            skills_names,
            userID,
            occupationsOriginal: [...occupationsOriginal],
            desiredOccupationsOriginal: [...desiredOccupationsOriginal],
          };

          let {jobs} = await post("/jobs/query/all_occupations", { data: payload });
          if(internalMobilityProvider){
            const {portaldetails:{internalRoles=[]}} = state
            const internalMobilityRolesList = internalRoles.map((item) => item.occupation[0])
            let existingOccs = []
            for(const key of Object.keys(jobs)){
              jobs[key] = jobs[key].filter((item) => internalMobilityRolesList.includes(item.occupation) || (item.alt_labels && item.alt_labels.some(r=> internalMobilityRolesList.includes(r)))).map((item) => {
                const roleTitle = internalRoles.find((_item) => _item.occupation.includes(item.occupation));
                if(roleTitle){
                  existingOccs.push(item.occupation);
                  existingOccs = [...existingOccs, item.occupation, ...roleTitle.preferredLabels]
                  existingOccs.push(item.occupation);
                }
                return {
                  ...item,
                  roleTitle: roleTitle ? roleTitle.roleName : false
                }
              })
            }
            for (const idx in payload.desiredExp){
              payload.occupations.push(payload.desiredOccupations[idx])
              payload.occupationsOriginal.push(payload.desiredOccupationsOriginal[idx])
            }
            payload.desiredExp = []
            payload.desiredOccupations = []
            payload.desiredOccupationsOriginal = []
            for (const role of internalRoles){
              if(!existingOccs.includes(role.occupation[0])){
                payload.desiredExp.push(false)
                payload.desiredOccupations.push(role.preferredLabels[0])
                payload.desiredOccupationsOriginal.push(role.occupation[0])
              }
            }
            if(payload.desiredExp.length > 0){
              let internalOccs = await post("/jobs/query/all_occupations", { data: payload });
              if(internalOccs && internalOccs.jobs){       
                  internalOccs.jobs.desired_occupations = internalOccs.jobs.desired_occupations.filter((item) => internalMobilityRolesList.includes(item.occupation) || (item.alt_labels && item.alt_labels.some(r=> internalMobilityRolesList.includes(r)))).map((item) => {
                  const roleTitle = internalRoles.find((_item) => _item.occupation.includes(item.occupation) || (item.alt_labels && item.alt_labels.some(r=> _item.occupation.includes(r))));
                    return {
                      ...item,
                      roleTitle: roleTitle ? roleTitle.roleName : false
                    }
                  })
                jobs.skills_backpack_occupations.push(...internalOccs.jobs.desired_occupations)
                jobs.skills_backpack_occupations = [...new Set(jobs.skills_backpack_occupations)]
                jobs.interest_occupations = _.cloneDeep(jobs.skills_backpack_occupations)
                jobs.styles_occupations = _.cloneDeep(jobs.skills_backpack_occupations)
              }
            } 
          }
          dispatch({
            type: FETCH_ALL_OCCUPATIONS,
            jobs,
          })
          dispatch({
            type: FETCH_COINS,
            data: coinsObject
          });
        } else {
          dispatch({ type: FETCH_CANDIDATE_DETAILS, selectedCandidate: {} });
        }
      }
    } catch (e) {
      logger.error("fetchCandidateDetails():", e);
      dispatch({ type: FETCH_CANDIDATE_DETAILS, selectedCandidate: {} });
    }
  };
}

export const inviteToVacancy = (userId, vacancy) => {
  let body = {
    userId:  userId,
    jobId: vacancy.jobId,
    jobTitle: vacancy.jobTitle,
    employer: vacancy.employerName,
    location : vacancy.original_location,
    salary : vacancy.annual_salary_min.toString(),
    invited : true ,
    rangeKey : vacancy.rangeKey
  };
  return async (dispatch) => {
    try {
      /*eslint-disable */
      let data = await post("/keyworker/invite/candidate/", body);

      let saveItem = await post("/keyworker/invite/candidate/saved/", {
        userID: userId,
        rangeKey : vacancy.rangeKey,
        jobitem : vacancy      });
      /*eslint-enable */
    } catch (e) {
      logger.error("inviteToVacancy():", e);
    }
  }
}

export const getMatches = (type = "interest") => async (dispatch, getState) => {
  try {
    const {
      candidates: {
        selectedCandidateData: {
          latestAssessmentResult,
          occupationsExtended,
          occupations,
          desiredExp,
          desiredOccupations,
          qualifications,
          skills_names
        },
      },
    } = getState();
    const url =
      type === "interest"
        ? `/jobs/query/interest_jobs_query`
        : `/jobs/query/styles_jobs_query`;
        
    // no data to make these calls.
    if (!latestAssessmentResult && 
      !occupationsExtended && 
      !occupations &&
      !desiredOccupations &&
      !qualifications &&
      !skills_names){
      return false;
    }
    const { jobs: matches } = await post(url, {
      data: {
        occupations,
        latestAssessmentResult,
        occupationsExtended,
        desiredOccupations,
        desiredExp,
        qualifications,
        skills_names
      },
    });

    dispatch({ type: FETCH_CANDIDATE_MATCHES, payload: { matches, type } });

  } catch (e) {
    console.log("error", e);
  }
};

export const getSkillsInfo = () => async (dispatch, getState) => {
  try {
    const {
      candidates: {
        selectedCandidateData: { occupations, desiredOccupations, occupationSkills } = {},
        skilValidationRequests = {}
        },
      } = getState();
      const { requests= [], completed= []} = skilValidationRequests;

    if (!desiredOccupations && !occupations) {
      return false;
    }
    
    let payload = {
      skills: []
    };      
    occupationSkills.forEach((skill, i) => {
      payload.skills.push(...skill.skills.map((individual_skill) => individual_skill.name))
      payload.skills.push(...skill.optionalSkills.map((individual_skill) => individual_skill.name))
      if(skill.deletedSkills){
        payload.skills.push(...skill.deletedSkills.map((individual_skill) => individual_skill.name))
      }
    })
    const { data } = await post("/data/skills/description", payload);
       
    function getDescAndTypes(skill_name){
      const f = data[skill_name.toLowerCase()];
      return {
        description: (f && f.description) ? f.description : "No description available",
        skill_types: (f && f.skill_types) ? f.skill_types : []
      }
    }
    function skillLoop(skill_list){
      return skill_list.map((individual_skill_object) => {
        const skillObj = getDescAndTypes(individual_skill_object.name);
        return {
          skill:individual_skill_object.name,
          proficiency: individual_skill_object.level,
          projectedLevel: individual_skill_object.projectedLevel,
          description: skillObj.description,
          skill_types: skillObj.skill_types,
          pendingValidationRequest: requests.find((item) => item.skill === individual_skill_object.name) ? true : false,
        }
      })
    }

    let skillsInfo = occupationSkills.map((skillObj) => {
      const skills = skillLoop(skillObj.skills)
      const optionalSkills = skillObj.optionalSkills ? skillLoop(skillObj.optionalSkills) : []
      const deletedSkills = skillObj.deletedSkills ? skillLoop(skillObj.deletedSkills) :  []
      return {
        title: skillObj['occupation'],
        skills,
        optionalSkills,
        deletedSkills
      };
    });

    const manuallyAddedIndex = skillsInfo.findIndex(obj => (obj.title.includes("Manually Added") || obj.title.includes("Resource Added Skills")));

    if (manuallyAddedIndex > -1) {
      const manuallyAddedItem = skillsInfo[manuallyAddedIndex];
      // Create a new array without the manually added item, then add it to the end.
      skillsInfo = skillsInfo.filter((_, index) => index !== manuallyAddedIndex);
      skillsInfo.push(manuallyAddedItem);
    }

    dispatch({ type: FETCH_CANDIDATE_SKILLS_INFO, skillsInfo });
  } catch (e) {
    console.log("error", e);
  }
};

export const getCandidateEngagements = () => async (dispatch, getState) => {

  try {
    const {
      auth: { role },
      portaldetails: {
        currentKeyWorker,
        user: { userID },
      },
      candidates: {
        selectedCandidateData: { userID: candidateUserId },
      },
    } = getState();

    const keyworkerId = role === "org-admin" ? currentKeyWorker : userID;


    const {
      data: {
        engagement,
        jobsApplied,
        jobsSaved,
        jobsViewed,
        quals = {},
        jobs = {},
        qualsApplied,
        qualsSaved,
        qualsViewed,
        resourceViewed,
        coursesViewed
      },
    } = await get(`/keyworker/${keyworkerId}/candidate/${candidateUserId}/engagement`);


    //TODO: move this to reducer
    if (engagement) {

      const dates = Object.keys(engagement).filter((key) =>
        key.match(/\d{4}-\d{1,2}-\d{1,2}/gm)
      );
      const engagementData = dates.map((dateString) => {
        const [year, month, date] = dateString.split("-");
        return {
          date: new Date(year, month - 1, date).toISOString(),
          duration: Math.round(engagement[dateString] / 60),
        };
      });
      engagementData.sort((a, b) => new Date(a.date) - new Date(b.date));

      const totalDuration = dates.reduce(
        (acl, curr) => acl + engagement[curr],
        0
      );

      const xmins = Math.floor(totalDuration / 60);
      const xhours = Math.floor(xmins / 60);

      var totalDurationFormatted =
        String(xhours) + " hours " + String(xmins - xhours * 60) + " minutes";

      if (xmins <= 60) {
        totalDurationFormatted = String(xmins) + " minutes";
      }

      dispatch({
        type: FETCH_CANDIDATE_ENGAGEMENTS,
        engagements: {
          chartData: engagementData,
          numberOfSessions: engagement.numberOfSessions,
          averageDurationSession: dates.length
            ? Math.round(totalDuration / 60 / engagement.numberOfSessions) +
              " mins"
            : "Not started",
          averageDurationDay: dates.length
            ? Math.round(totalDuration / 60 / dates.length) + " mins"
            : "Not started",
          totalDuration,
          totalDurationFormatted,
        },
        jobsViewed,
        jobsApplied,
        jobsSaved,
        qualsApplied,
        qualsSaved,
        qualsViewed,
        quals,
        jobs,
        resourceViewed,
        coursesViewed
      });
    } else {
      dispatch({
        type: FETCH_CANDIDATE_ENGAGEMENTS,
        engagements: null,
        jobsViewed,
        jobsApplied,
        jobsSaved,
        qualsApplied,
        qualsSaved,
        qualsViewed,
        resourceViewed,
        coursesViewed
      });
    }

  } catch (e) {
    console.log("error", e);
  }
};

export const getCandidateJobMatches = () => async (dispatch, getState) => {
  try {
    const {
      candidates: {
        selectedCandidateData: {
          latestAssessmentResult,
          occupations,
          occupationsExtended,
          qualifications,
        },
      },
    } = getState();
    const {
      jobs: {
        sb_tech_backpack: [backpack],
        tech_int_styles: {
          Interests: [interestOne, interestTwo],
          Styles: [stylesOne, stylesTwo],
        },
        sb_backpack: [normalBackpack],
        normal_int_styles: {
          added_occs_styles: [normalStyleOne, normalStyleTwo],
          added_occs_interests: [normalInterestOne, normalInterestTwo],
        },
      },
    } = await post("/jobs/int_styles", {
      data: {
        latestAssessmentResult,
        occupations,
        htmlStrip: true,
        occupationsExtended,
        qualifications,
      },
    });

    const techJobMatches = []
      .concat({
        url: backpack.url,
        sector: backpack.sector,
        interestScore: backpack.interests_score,
        stylesScore: backpack.styles_score,
        title: backpack.most_similar_occ,
        interests: backpack.interests_normal,
        styles: backpack.styles_normal,
        skills: backpack.similarity_in_skills,
        skillScore: backpack.similarity,
      })
      .concat(
        [interestOne, interestTwo, stylesOne, stylesTwo].map(
          ([
            title,
            stylesScore,
            interestScore,
            skillScore,
            sector,
            url,
            interests,
            styles,
            skills,
          ]) => ({
            url,
            sector,
            skillScore,
            interestScore,
            stylesScore,
            title,
            interests,
            styles,
            skills,
          })
        )
      );

    const normalJobMatches = []
      .concat({
        interestScore: normalBackpack.interests_score,
        stylesScore: normalBackpack.styles_score,
        title: normalBackpack.most_similar_occ,
        interests: normalBackpack.interests_normal,
        styles: normalBackpack.styles_normal,
        skills: normalBackpack.similarity_in_skills,
        skillScore: normalBackpack.similarity,
      })
      .concat(
        [
          normalInterestOne,
          normalInterestTwo,
          normalStyleOne,
          normalStyleTwo,
        ].map(
          ([
            title,
            stylesScore,
            interestScore,
            skillScore,
            interests,
            styles,
            skills = [],
          ]) => ({
            skillScore,
            interestScore,
            stylesScore,
            title,
            interests,
            styles,
            skills,
          })
        )
      );

    dispatch({
      type: FETCH_CANDIDATE_JOB_MATCHES,
      payload: { techJobMatches, normalJobMatches },
    });

  } catch (e) {
    console.log("error", e);
  }
};

export function addNewSkill(skills) {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID, occupationSkills=[] } = selectedCandidateData;
      let newOccupationSkills = occupationSkills
      let skillObjIdx = null
      let newSkillList = skills.map((item) => {return {"name": item, "level": 1}})

      occupationSkills.forEach(function (item, index) {
        if (item.occupation === "Manually Added: Skills"){
          skillObjIdx = index
        }
      });
      
      if(skillObjIdx){
        newOccupationSkills[skillObjIdx].skills.push(...newSkillList)
      }
      else{
        skillObjIdx = newOccupationSkills.length
        newOccupationSkills.push({'occupation': "Manually Added: Skills", 'expertise': "Beginner", 'skills': newSkillList, 'optionalSkills': [], 'deletedSkills':[]})
      }


      const data = await post("/keyworker/candidateskills", {
        userID: userID,
        occupationSkills: newOccupationSkills
      });
      await dispatch({
        type: SET_NEW_SKILLS,
        newOccupationSkills: newOccupationSkills,
      });
      await dispatch(getSkillsInfo());

    } catch (e) {
      logger.error("addNewSkill():", e);
    }
  }
}

export function editSkillLevel(skill, level) {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { occupationSkills=[], skillsInfo=[] } = selectedCandidateData;
      function skillLoop(skill_list){
        return skill_list.map((_item) => {
          if(_item.skill === skill || _item.name === skill){
            return {..._item, projectedLevel: level}
          }
          else{
            return _item
          }
        })
      }

      const newSkillsInfo = skillsInfo.map((item) => {
        return {...item, skills: skillLoop(item.skills), optionalSkills: item.optionalSkills ? skillLoop(item.optionalSkills) : [], deletedSkills: item.deletedSkills ? skillLoop(item.deletedSkills) : []}
      })

      const newOccupationSkills = occupationSkills.map((item) => {
        return {...item, skills: skillLoop(item.skills), optionalSkills: item.optionalSkills ? skillLoop(item.optionalSkills) : [], deletedSkills: item.deletedSkills ? skillLoop(item.deletedSkills) : []}
      })

      console.log(newOccupationSkills)
      console.log(newSkillsInfo)

      await dispatch({type: SET_NEW_SKILLS, newOccupationSkills: newOccupationSkills});
      dispatch({ type: FETCH_CANDIDATE_SKILLS_INFO, skillsInfo: newSkillsInfo });

    } catch (e) {
      logger.error("editSkillLevel():", e);
    }
  }
}


export function saveSkills(skills) {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID, occupationSkills=[] } = selectedCandidateData;

      const data = await post("/keyworker/candidateskills", {
        userID: userID,
        occupationSkills: occupationSkills
      });

      dispatch(setSkillUpdates(skills))

    } catch (e) {
      logger.error("saveSkills():", e);
    }
  }
}


export function fetchValidationRequests() {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID } = selectedCandidateData;

      const data = await post("/keyworker/validationrequests/get", {
        userID: userID
      });
      if(data && data.success){
        dispatch({ type: FETCH_VALIDATION_REQUESTS, data: data.data });
      }
      else{
        dispatch({ type: FETCH_VALIDATION_REQUESTS, data: []});
      }
    } catch (e) {
      logger.error("fetchValidationRequests():", e);
    }
  }
}

export function createValidationRequest(skill) {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID, skillsInfo } = selectedCandidateData;

      const data = await post("/keyworker/validationrequests/set", {
        userID: userID,
        skill: skill
      });
      if(data && data.success){
        dispatch({ type: FETCH_VALIDATION_REQUESTS, data: data.data });

        function skillLoop(skill_list){
          return skill_list.map((individual_skill_object) => ({
            ...individual_skill_object,
            pendingValidationRequest: data.data.requests.find((item) => item.skill === individual_skill_object.skill) ? true : false,
          }))
        }

        let newSkillsInfo = skillsInfo.map((skillObj) => {
          const skills = skillLoop(skillObj.skills)
          const optionalSkills = skillObj.optionalSkills ? skillLoop(skillObj.optionalSkills) : []
          const deletedSkills = skillObj.deletedSkills ? skillLoop(skillObj.deletedSkills) :  []
          return {
            ...skillObj,
            skills: skills,
            optionalSkills: optionalSkills,
            deletedSkills: deletedSkills
          };
        });
        console.log(newSkillsInfo)
        dispatch({ type: FETCH_CANDIDATE_SKILLS_INFO, skillsInfo:newSkillsInfo });

      }
      else{
        dispatch({ type: FETCH_VALIDATION_REQUESTS, data: {}});
      }

    } catch (e) {
      logger.error("createValidationRequest():", e);
    }
  }
}

export function setSkillUpdates(skills) {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID } = selectedCandidateData;

      const data = await post("/keyworker/projectedskills/set", {
        userID: userID,
        skills: skills      });
    } catch (e) {
      logger.error("setSkillUpdates():", e);
    }
  }
}

export function fetchProjectUtilisation() {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID, provider } = selectedCandidateData;

      const data = await post("/employer/user/get/allutilisation", {
        userID: userID,
        provider: provider
      });

      dispatch({ type: FETCH_CANDIDATE_PROJECTS, data: data.data ? data.data : []});
    } catch (e) {
      logger.error("fetchProjectUtilisation():", e);
    }
  }
}


export function fetchProjectUtilisationDateChange(data, date) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: FETCH_CANDIDATE_PROJECTS, data: data, date:date});
    } catch (e) {
      logger.error("fetchProjectUtilisationDateChange():", e);
    }
  }
}

export function setEmployeeUtilisation(newWeeklyWorkingHours, newCoreRoleUtilisation) {
  return async function (dispatch, getState) {
    try {
      const { candidates: { selectedCandidateData = {} } } = getState();
      const { userID, provider } = selectedCandidateData;

      const data = await post("/employer/user/set/utilisation", {
        userID: userID,
        weeklyWorkingHours: newWeeklyWorkingHours, 
        coreRoleUtilisationPercentage: newCoreRoleUtilisation,
        provider: provider
      });
      if(data && data.success && data.data){
        dispatch({ type: FETCH_CANDIDATE_DETAILS, selectedCandidate: {...selectedCandidateData, ...data.data}});
      }
    } catch (e) {
      logger.error("setEmployeeUtilisation():", e);
    }
  }
}